/**
 * True if `userRoles` contains at least one of the `required` roles.
 * Shared by the `v-has-access-by-role` directive and connector-button gating.
 * @param {string[]} userRoles - roles from authStore user data
 * @param {string|string[]} required - role or roles that grant access
 * @returns {boolean}
 */
export const hasAnyRole = (userRoles = [], required) => {
  if (!required) {
    return false;
  }
  const requiredRoles = Array.isArray(required) ? required : [required];
  return requiredRoles.some((role) => userRoles.includes(role));
};
